import { render, staticRenderFns } from "./PaymentRecordsChart.vue?vue&type=template&id=3159059a&scoped=true"
import script from "./PaymentRecordsChart.vue?vue&type=script&lang=js"
export * from "./PaymentRecordsChart.vue?vue&type=script&lang=js"
import style0 from "./PaymentRecordsChart.vue?vue&type=style&index=0&id=3159059a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3159059a",
  null
  
)

export default component.exports